/**
 * 马甲包主题兼容工具
 * Theme compatibility utilities for different app packages
 */
import { isPartyHero } from './index';

/**
 * PartyHero 图片路径兼容处理
 * @param imageName 图片文件名（不含路径）
 * @param defaultPath 默认图片完整路径（可选，如果不提供则自动从 @/assets/images/ 获取）
 * @returns 根据 install_package 返回对应的图片路径
 * @example
 * // 自动处理路径
 * getPartyHeroImage('logo.png')
 * // 返回: isPartyHero ? '/src/assets/images/partyhero/logo.png' : '/src/assets/images/logo.png'
 *
 * // 手动指定默认路径
 * getPartyHeroImage('logo.png', '/src/assets/images/custom/logo.png')
 */
export function getPartyHeroImage(imageName: string, defaultPath?: string): string {
  if (isPartyHero()) {
    // PartyHero 模式：从 partyhero 文件夹获取
    return new URL(`../../assets/images/partyhero/${imageName}`, import.meta.url).href;
  }
  // 默认模式：使用提供的路径或从默认文件夹获取
  return defaultPath || new URL(`../../assets/images/${imageName}`, import.meta.url).href;
}

/**
 * 初始化主题（添加 body class）
 * 应在应用启动时调用
 */
export function initTheme(): void {
  if (isPartyHero()) {
    document.body.classList.add('party-hero');
  } else {
    document.body.classList.remove('party-hero');
  }
}
